import { useState, useEffect } from 'react';
import axios from 'axios';

const useTimeServer = () => {
    const [currentDate, setCurrentDate] = useState(null);

    useEffect(() => {
        const fetchServerTime = async () => {
            try {
                const response = await axios.get('/api/time/current-time');
                const serverTime = new Date(response.data.currentTime);
                setCurrentDate(serverTime);
            } catch (error) {
                // console.error("Ne može se dobiti tačno vrijeme sa servera.", error);
                setCurrentDate(new Date());
            }
        };

        fetchServerTime();
    }, []);

    return currentDate; // Vraćamo direktno Date objekat umesto { currentDate }
};

export default useTimeServer;
